import React from "react";
import { View, Text } from "react-native";
import { When } from "react-if";

import styles from "./styles";

const HeaderTabs = ({
  title,
  subtitle,
  containerStyle = {},
  titleStyle = {},
  subtitleStyle = {},
}) => {
  return (
    <View style={[styles.container, containerStyle]}>
      <Text style={[styles.titleText, titleStyle]}>{title}</Text>
      <When condition={subtitle}>
        <Text style={[styles.subtitle, subtitleStyle]}>{subtitle}</Text>
      </When>
    </View>
  );
};

export default HeaderTabs;
